import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/ServiceCategories";
import getToken from "app/api/getToken";
import { IServiceCategory } from "app/api/types";

export const ADD_SERVICE_CATEGORY_REQUEST = "ADD_SERVICE_CATEGORY_REQUEST";
export const ADD_SERVICE_CATEGORY_SUCCESS = "ADD_SERVICE_CATEGORY_SUCCESS";
export const ADD_SERVICE_CATEGORY_FAIL = "ADD_SERVICE_CATEGORY_FAIL";

export const addServiceCategory = (data: IServiceCategory) => (
  dispatch: any
): any => {
  dispatch({ type: ADD_SERVICE_CATEGORY_REQUEST });

  const token = getToken();

  return api
    .addServiceCategory(token, data)
    .then((response: AxiosResponse) => {
      const serviceCategory: IServiceCategory = get(response, "data", {});
      dispatch({
        type: ADD_SERVICE_CATEGORY_SUCCESS,
        payload: serviceCategory
      });

      return serviceCategory;
    })
    .catch(err => {
      dispatch({
        type: ADD_SERVICE_CATEGORY_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
